export default "__VITE_PUBLIC_ASSET__75860f5c__"